module.exports = __webpack_public_path__ + "img/3.bd47d43.png";